import { useApp } from "../contexts/AppContext";
import OfficerCard from "../components/OfficerCard";

export default function AboutPage() {
  const { about } = useApp();

  return (
    <div>
      <div className="pg-hdr">
        <h1>About LHDA</h1>
        <p>Representing the customary landowners of Lomban Falls on the Lai River, Wabag District, Enga Province, Papua New Guinea.</p>
      </div>

      <section className="sec">
        <div className="container">
          <div className="grid2" style={{ marginBottom: "3rem" }}>
            <div className="mv-g"><div className="mv-icon">🎯</div><div className="mv-title">Mission</div><p className="mv-text">{about.mission}</p></div>
            <div className="mv-b"><div className="mv-icon">🔭</div><div className="mv-title">Vision</div><p className="mv-text">{about.vision}</p></div>
          </div>

          <div style={{ background:"#fff", border:"1.5px solid var(--br)", borderRadius:16, padding:"2.5rem", boxShadow:"var(--sh)" }}>
            <h3 style={{ fontFamily:"'Playfair Display',serif", fontSize:"1.5rem", marginBottom:"1.25rem", color:"var(--gd)" }}>Our History</h3>
            <p className="hist-txt">{about.history}</p>
          </div>

          <div className="divider"/>

          <div className="sec-hdr">
            <div className="eyebrow">Leadership</div>
            <h2>Executive Committee</h2>
            <p>Elected representatives guiding LHDA on behalf of all Kaiyaul and Piau customary landowners.</p>
          </div>
          <div className="officers-grid">
            {about.officers.map((o, i) => <OfficerCard key={i} officer={o}/>)}
          </div>

          <div className="divider"/>

          <div className="sec-hdr">
            <div className="eyebrow">Clans &amp; Families</div>
            <h2>Membership Structure</h2>
            <p>48 founding Family Representatives from 5 subclans across two landowning clans.</p>
          </div>
          <div className="grid2">
            {[
              { clan:"Kaiyaul Clan (Awain Tribe)", bank:"Western bank, Lai River", color:"mv-g",
                sub:["Milikin Subclan (19 families): Abal, Angopae, Elisha, Irai, Kiponge, Lamb, Lau, Lyamb, Neayak, Paen, Paki, Pimbik, Puio, Sairos, Tangupae, Yakaly, Yakan, Yangun, Yongapen","Kandelyo Subclan (4 families): Kaik, Kemb, Kolalyo, Lemb"] },
              { clan:"Piau Clan (Yanaitin Tribe)", bank:"Eastern bank, Lai River", color:"mv-b",
                sub:["Kumun Subclan (2 families): Lum, Yapari","Yaki Subclan (13 families): Aipingi, Husukun, Iki, Kakale, Karao, Kiyakaen, Komba, Korakan, Nalakau, Nallao, Polyan, Yakinarae, Yapok","Piole Subclan (10 families): Eyakan, Henry, Kepakan, Lipai, Mailyo, Mendokon, Pakau, Puki, Talikin, Timbai"] },
            ].map((c, i) => (
              <div key={i} className={c.color} style={{ padding: "2rem" }}>
                <div style={{ fontWeight:700, fontSize:"1.1rem", fontFamily:"'Playfair Display',serif", marginBottom:".4rem" }}>{c.clan}</div>
                <div style={{ fontSize:".8rem", opacity:.75, marginBottom:"1rem" }}>📍 {c.bank}</div>
                {c.sub.map((s, j) => <p key={j} style={{ fontSize:".85rem", opacity:.88, marginBottom:".6rem", lineHeight:1.6 }}>• {s}</p>)}
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
